import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EvaluadosDto } from 'src/app/dto/evaluados-dto';

@Component({
  selector: 'app-respuesta-evaluado',
  templateUrl: './respuesta-evaluado.component.html',
  styleUrls: ['./respuesta-evaluado.component.css']
})
export class RespuestaEvaluadoComponent implements OnInit {

  public load: boolean;
  array: EvaluadosDto[];
  RespuestaEstudiante: any[];
  RespuestaDocente: any[];
  RespuestaDocentePar: any[];
  RespuestaDecano: any[];
  Respuesta: any[];
  RespuestaD: any[];
  mostrarEstudiante = false;
  mostrarDocente = false;
  mostrarDecano = false;
  NombreDocente: string;
  promedio: any;

  constructor(private dialogRef: MatDialogRef<RespuestaEvaluadoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { this.load = false; }

  ngOnInit() {
    this.adjustDialogSize();

    if (this.data.item == true) {
      this.mostrarDecano = true;
      this.RespuestaDocentePar = this.data.evaluados.filter(persona => persona.docente == this.data.evaluadoDocente);
      this.RespuestaDocentePar.map((item: any) => {
        this.Respuesta = item.respuestas;
        this.NombreDocente = item.nombre + ' ' + item.apellido;
      })

    } else {

      if (this.data.Listaevaluados != null) {
        this.mostrarEstudiante = true;
        this.RespuestaEstudiante = this.data.Listaevaluados.filter(persona => persona.curso == this.data.evaluadoCurso && persona.docente == this.data.evaluadoDocente);
        this.RespuestaEstudiante.map((item: any) => {
          this.Respuesta = item.respuestas;
          this.NombreDocente = item.nombre + ' ' + item.apellido;
        })
      } else {
        if (this.data.Evaluados != null) {
          this.mostrarDocente = true;

          this.RespuestaDocente = this.data.Evaluados.filter(persona => persona.docente == this.data.evaluadoDocente);
          this.RespuestaDocente.map((item: any) => {
            this.RespuestaD = item.respuestas;
            this.NombreDocente = item.nombre + ' ' + item.apellido;
          })
        }
      }
    }

    setTimeout(() => {
      this.load = true;
    }, 1000);
  }

  private adjustDialogSize() {
    if (window.innerWidth < 768) {
      this.dialogRef.updateSize('95%', '90%');
    } else {
      this.dialogRef.updateSize('80%', '80%');
    }
  }
}
